import { Check } from "lucide-react";
import { slugify } from "@/lib/format";
import { cn } from "@/lib/utils";

// Choix parmi les options d'une sélection Notion (multiple par défaut, unique avec `single`)
export function OptionPicker({ options = [], value, onChange, single = false, testId }) {
  const values = single ? (value ? [value] : []) : value || [];
  const toggle = (o) => {
    if (single) return onChange(value === o ? "" : o);
    onChange(values.includes(o) ? values.filter((v) => v !== o) : [...values, o]);
  };
  if (!options.length) return <p className="text-sm text-muted-foreground">Aucune option dans Notion.</p>;
  return (
    <div className="flex flex-wrap gap-2" data-testid={testId}>
      {options.map((o) => {
        const on = values.includes(o);
        return (
          <button type="button" key={o} onClick={() => toggle(o)} aria-pressed={on} data-testid={`${testId}-option-${slugify(o)}`}
            className={cn("inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-semibold transition-[background-color,border-color,color]",
              on ? "border-primary/40 bg-accent text-primary" : "border-border bg-white text-stone-600 hover:border-stone-300")}>
            {on && <Check className="h-3.5 w-3.5" />}{o}
          </button>
        );
      })}
    </div>
  );
}
